import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { BottomButtonsLayout, Button, theme, Title } from 'aimo-ui';
import ChargingReportContent from 'components/receipt/ChargingReportContent';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import {
  CenterColumn,
  ColumnWithMargins,
  RowSpaceBetween,
  ScreenContainer,
  ScreenWrapper,
  StyledImage,
  StyledWrapper,
} from 'styles/ContainerStyles';
import { StopChargingSessionResponse } from 'types/generatedSchemaTypes';
import { RootNavProps, RootStackParamList } from 'types/navigation';
import { isWeb } from 'utils/deviceUtils';
import { testIdentifiers } from 'utils/testIdentifiers';

const GetSheetLayout = ({
  sessionData,
}: {
  sessionData?: StopChargingSessionResponse;
}) => {
  if (isWeb) {
    return <ChargingReportContent sessionData={sessionData} />;
  }
  return <ChargingReportContent sessionData={sessionData} />;
};

const ChargingReportScreen = () => {
  const { t } = useTranslation();
  const { params } =
    useRoute<RouteProp<RootStackParamList, 'chargingReport'>>();
  const data = params?.receiptData || {};
  const { navigate } = useNavigation<RootNavProps>();
  return (
    <BottomButtonsLayout
      contentBottom={
        <StyledWrapper mb={2} center maxWidth={300}>
          <Button
            {...testIdentifiers('parking-receipt-confirm-button')}
            size="l"
            fullWidth={true}
            text={t('button.close')}
            onPress={() => navigate('mainTabs', { screen: 'parkScreen' })}
            loading={false}
          />
        </StyledWrapper>
      }>
      <ScreenContainer
        background={isWeb ? theme.colors.white : theme.colors.gray50}>
        <ScreenWrapper padding={0} tabBarHeight={10}>
          <StyledWrapper center maxWidth={550}>
            <ColumnWithMargins mb={40}>
              <RowSpaceBetween padding={0}>
                <View />
              </RowSpaceBetween>
            </ColumnWithMargins>

            <CenterColumn>
              <StyledImage
                testID="charging-report-image"
                width={173}
                height={62}
                center
                source={require('assets/images/parking-receipt-car.png')}
              />
              <Title center testID="charging-report-header">
                {t('evCharging.receipt.header')}
              </Title>
            </CenterColumn>
          </StyledWrapper>
          {isWeb && <GetSheetLayout sessionData={data} />}
          {!isWeb && <GetSheetLayout sessionData={data} />}
        </ScreenWrapper>
      </ScreenContainer>
    </BottomButtonsLayout>
  );
};

export default ChargingReportScreen;
